import { createContext } from "react";

export type NotificationListener = (event: string, data: unknown) => void;

export interface NotificationContextValue {
  readonly addListener: (listener: NotificationListener) => void;
  readonly removeListener: (listener: NotificationListener) => void;
}

export const NotificationContext =
  createContext<NotificationContextValue | null>(null);
